import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { filter } from 'rxjs';
import { UserInformation } from '@models/user-information.model';
import { EnvService } from '../services/env.service';
import { UserService } from '../services/user.service';

@Injectable({
  providedIn: 'root',
})
export class AuthInterceptorService implements HttpInterceptor {
  constructor(
    private envService: EnvService,
    private userService: UserService,) {
    this.userService.UserInformation.pipe(filter((item): item is UserInformation => item !== null))
      .subscribe(info => {
        this.userInfo = info;
    });
  }

  private userInfo!: UserInformation;

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    if (req.url.startsWith(`https://coregis${this.envService.env1}commandcentral.${this.envService.domainExtension}`)) {
      const access_token = this.userInfo.token;
      req = req.clone({
        headers: req.headers.set('Authorization', 'Bearer ' + access_token),
      });
      return next.handle(req);
    } else {
      return next.handle(req);
    }
  }
}
